import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteMediaContext = createContext({});

export const SiteMediaProvider = ({ children }) => {
  const [media, setMedia] = useState({});
  useEffect(() => { api.get("/public/site-media").then((r) => setMedia(r.data)).catch(() => {}); }, []);
  return <SiteMediaContext.Provider value={media}>{children}</SiteMediaContext.Provider>;
};

export const useSiteMedia = () => useContext(SiteMediaContext);
